import React, { useState, useEffect } from "react";
import {
  Button,
  Input,
  Select,
  Switch,
  Divider,
  Upload,
  InputNumber,
} from "antd";
import {
  UploadOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { uploadImage } from "../../../../utils/utility";
import { useProjectState } from "../../../../context/stateContext";

const { TextArea } = Input;

const EditTabsPaymentsSetting = ({ sendPaymentsState, organization }) => {
  const [paymentsConfigurationSplitBill, setPaymentsConfigurationSplitBill] =
    useState(null);
  const [paymentsConfigurationEnabled, setPaymentsConfigurationEnabled] =
    useState(null);
  const [qrMenuLink, setQrMenuLink] = useState(null);
  const [surveyUrl, setSurveyUrl] = useState(null);
  const [minimumPaymentAmount, setMinimumPaymentAmount] = useState(0);
  const [billLogo, setBillLogo] = useState(null);
  const [receiptConfigurationHeader, setReceiptConfigurationHeader] =
    useState(null);
  const [receiptConfigurationFooter, setReceiptConfigurationFooter] =
    useState(null);
  const [payBillItemStatusThreshold, setPayBillItemStatusThreshold] =
    useState(null);
  const { openEditOrganizationModal } = useProjectState();

  const paymentsState = {
    paymentsConfigurationSplitBill,
    paymentsConfigurationEnabled,
    qrMenuLink,
    surveyUrl,
    minimumPaymentAmount,
    billLogo,
    payBillItemStatusThreshold,
    receiptConfigurationHeader,
    receiptConfigurationFooter,
  };

  useEffect(() => {
    sendPaymentsState(paymentsState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(paymentsState)]);

  useEffect(() => {
    setPaymentsConfigurationSplitBill(
      organization?.myMenuConfiguration?.paymentConfiguration
        ?.splitPaymentEnabled
    );
    setPaymentsConfigurationEnabled(
      organization?.myMenuConfiguration?.paymentConfiguration?.paymentsEnabled
    );
    setQrMenuLink(
      organization?.myMenuConfiguration?.paymentConfiguration?.qrMenuLink
    );
    setSurveyUrl(
      organization?.myMenuConfiguration?.paymentConfiguration?.surveyUrl
    );
    setMinimumPaymentAmount(
      organization?.myMenuConfiguration?.paymentConfiguration
        ?.minimumPaymentAmount
    );
    setBillLogo(
      organization?.myMenuConfiguration?.paymentConfiguration?.billLogo
    );
    setReceiptConfigurationHeader(
      organization?.myMenuConfiguration?.paymentConfiguration
        ?.receiptConfiguration?.header
    );
    setReceiptConfigurationFooter(
      organization?.myMenuConfiguration?.paymentConfiguration
        ?.receiptConfiguration?.footer
    );
    setPayBillItemStatusThreshold(
      organization?.myMenuConfiguration?.paymentConfiguration
        ?.payBillItemStatusThreshold
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization, openEditOrganizationModal]);

  const payBillStatus = [
    {
      value: 0,
      label: "Получена",
    },
    { value: 1, label: "Приета" },
    { value: 2, label: "В процес" },
    { value: 3, label: "Сервирано" },
  ];

  return (
    <>
      <div className="admin-organization-edit-payment-sections-toggle-container">
        <div>
          <label
            style={{ marginRight: "10px" }}
            className="admin-organization-edit-input-label"
          >
            Плащания
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={paymentsConfigurationEnabled}
            onChange={(value) => setPaymentsConfigurationEnabled(value)}
          />
        </div>
        <div>
          <label
            style={{ marginRight: "10px" }}
            className="admin-organization-edit-input-label"
          >
            Раздели и Плати
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={paymentsConfigurationSplitBill}
            onChange={(value) => setPaymentsConfigurationSplitBill(value)}
          />
        </div>
      </div>
      {paymentsConfigurationEnabled && (
        <>
          <Divider />
          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Статус за плащане
              </label>
              <Select
                value={payBillItemStatusThreshold}
                options={payBillStatus}
                onChange={(value) => setPayBillItemStatusThreshold(value)}
                className="admin-organization-full-width"
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Линк за дигитално меню
              </label>
              <Input
                value={qrMenuLink}
                onChange={(e) => setQrMenuLink(e.target.value)}
              />
            </div>
          </div>
          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Линк за анекти
              </label>
              <Input
                value={surveyUrl}
                onChange={(e) => setSurveyUrl(e.target.value)}
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Минимална сума за плащане
              </label>
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                value={minimumPaymentAmount}
                parser={(value) =>
                  parseInt(value.replace(/[^\d]/g, ""), 10) || 0
                } // Remove non-numeric characters
                onChange={(inputValue) =>
                  setMinimumPaymentAmount(inputValue > 0 ? inputValue : 0)
                }
              />
            </div>
          </div>
          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Фискален бон - клише
              </label>
              <TextArea
                rows={3}
                value={receiptConfigurationHeader}
                onChange={(e) =>
                  setReceiptConfigurationHeader(e?.target?.value?.split(","))
                }
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Фискален бон - съобщение
              </label>
              <TextArea
                rows={3}
                value={receiptConfigurationFooter}
                onChange={(e) =>
                  setReceiptConfigurationFooter([e?.target?.value])
                }
              />
            </div>
          </div>
          <Divider />

          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <p className="admin-organization-image-text">Лого бележка</p>
              {billLogo !== null && (
                <img
                  src={`data:image/jpeg;base64,${billLogo?.substring(
                    billLogo?.indexOf(",") + 1
                  )}`}
                  className="admin-organization-uploaded-image"
                  alt="bill-logo"
                />
              )}
              <div className="admin-organization-edit-upload-image-container">
                <Upload
                  showUploadList={false}
                  onChange={(e) => uploadImage(e, setBillLogo)}
                  accept="image/png,image/jpeg,image/webp"
                  beforeUpload={() => false}
                >
                  <Button
                    className="admin-organization-upload-button"
                    type="primary"
                    icon={<UploadOutlined />}
                    size="large"
                  >
                    Качи файл
                  </Button>
                </Upload>
              </div>
            </div>
          </div>
        </>
      )}
      <Divider />
    </>
  );
};

export default EditTabsPaymentsSetting;
